module.exports = __webpack_public_path__ + "assets/img/chooseRoleComponentCardIcon2.885af136.svg";